import {
    DriverLicense,
    HealthCard,
    LicensePlate,
    LocalizedValueType,
    PhotoCard,
} from '~/models/profile';
import { StoreStateProps } from './types';
import { INBOX_PAGE_SIZE } from '~/constants';

const INITIAL_STATE: StoreStateProps = {
    intendedFlow: '',
    renewalFlow: '',
    isLoading: false,
    languagePref: '',
    callerInfo: {
        verifiedBy: '',
        callerUrl: '',
    },
    customer: {
        details: {
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: '',
            gender: '',
            knownGenderPronoun: '',
            customGenderPronoun: '',
            agreedToTermsOfUseOn: '',
            myAccountAgreedOn: '',
            profileTier: '',
            isVerifiable: false,
        },
        address: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            provinceCode: '',
            postalCode: '',
            countryCode: '',
        },
        products: {
            driverLicense: {
                number: '',
                expiryDate: '',
                postalCode: '',
                validatedOn: '',
                status: {} as LocalizedValueType,
            } as DriverLicense,
            photoCard: {
                number: '',
                expiryDate: '',
                postalCode: '',
                validatedOn: '',
                status: {} as LocalizedValueType,
            } as PhotoCard,
            healthCard: {
                number: '',
                versionCode: '',
                controlNumber: '',
                postalCode: '',
                dateOfBirth: '',
            } as HealthCard,
            licensePlate: {
                number: '',
                permitNumber: '',
                registrantIdentificationNumber: '',
            } as LicensePlate,
        },
    },
    draftsAndForms: [],
    renewalReminder: {
        subscribedProducts: [],
        contactReferences: [],
    },
    licensePlateRenewal: { details: [] },
    registeredProducts: [],
    addressChange: {},
    productRenewal: {
        isVerificationRequired: false,
        suppressIneligibleBanner: false,
    },
    aiPhotoData: {
        photoData: {
            productDetails: {
                postalCode: '',
                documentNumber: '',
            },
            accountInfo: {
                firstName: '',
                lastName: '',
                middleName: '',
            },
            addressInfo: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                province: '',
                streetSuffix: '',
            },
            dateOfExpiration: '',
        },
    },
    inbox: {
        mode: 'inbox',
        messages: [],
        pageNumber: 1,
        pageSize: INBOX_PAGE_SIZE,
        numOfMessages: 0,
        numOfStarredMessages: 0,
        numOfUnreadMessages: 0,
        inboxError: false,
    },
    isReminderActive: false,
    payFine: {
        messages: [
            {
                messageType: '',
                messageNumber: '',
                messageText: '',
            },
        ],
        driverFees: [
            {
                feeCode: '',
                feeAmount: 0,
                feeRequiredCode: '',
                productName: '',
                orderLineItemId: 0,
            },
        ],
        driverFines: [
            {
                productName: '',
                caseDetails: [
                    {
                        caseNumber: '',
                        caseCount: 0,
                        offenceCode: '',
                        offenceCaseNumber: '',
                        convictionDate: '',
                        offenceDate: '',
                        courtNumber: '',
                        caseFee: 0,
                        courtLocation: '',
                        offenceName: '',
                        offenceDescription: '',
                        courtLocationEnglish: '',
                        courtLocationFrench: '',
                        offenceNameEnglish: '',
                        offenceDescriptionEnglish: '',
                        offenceNameFrench: '',
                        offenceDescriptionFrench: '',
                        orderLineItemId: 0,
                    },
                ],
            },
        ],
        ampFeesDetails: [
            {
                amp: '',
                totalFee: 0,
                productName: '',
                ampFeesDetails: [
                    {
                        suspensionNumber: '',
                        feeCode: '',
                        ampAmount: 0,
                        orderLineItemId: 0,
                        ampTypeCode: '',
                    },
                ],
            },
        ],
        versionNumber: '',
        dlNumber: '',
        orderId: '',
        orderGUID: '',
        clientId: '',
        clientName: '',
        sessionId: '',
        din: '',
        businessTransactionNumber: '',
    },
    payFineGuest: {
        driverLicenseNumber: '',
        driverLicenseClass: '',
        visionCondition: '',
        fullName: '',
        DOB: '',
        email: '',
        confirmationEmail: '',
        confirmEmail: false,
        phoneNumber: '',
        extension: '',
        streetAddress: '',
        municipality: '',
        postalCode: '',
        offenceNumber: '',
        suspensionNumber: '',
    },
    selectedFinesObj: {
        messages: [
            {
                messageType: '',
                messageNumber: '',
                messageText: '',
            },
        ],
        driverFees: [
            {
                feeCode: '',
                feeAmount: 0,
                feeRequiredCode: '',
                productName: '',
            },
        ],
        driverFines: [
            {
                productName: '',
                caseDetails: [
                    {
                        caseNumber: '',
                        caseCount: 0,
                        offenceCode: '',
                        offenceCaseNumber: '',
                        convictionDate: '',
                        offenceDate: '',
                        courtNumber: '',
                        caseFee: 0,
                        courtLocation: '',
                        offenceName: '',
                        offenceDescription: '',
                        courtLocationEnglish: '',
                        courtLocationFrench: '',
                        offenceNameEnglish: '',
                        offenceDescriptionEnglish: '',
                        offenceNameFrench: '',
                        offenceDescriptionFrench: '',
                    },
                ],
            },
        ],
        ampFeesDetails: [
            {
                amp: '',
                totalFee: 0,
                productName: '',
                ampFeesDetails: [
                    {
                        suspensionNumber: '',
                        feeCode: '',
                        ampAmount: 0,
                    },
                ],
            },
        ],
        versionNumber: '',
        dlNumber: '',
    },
    selectedFinesValue: false,
    checkAmp: [],
    checkReinst: [],
    cancelOrderSuccessMessage: false,
    declineOrderStatus: false,
    payFineAttempts: 0,
    paymentOrderDate: {
        emailId: '',
        orderId: '',
        firstName: '',
        lastName: '',
        orderStatus: '',
        partyId: 0,
    },
    products: {},
    verifyProductInfo: {
        binding: '',
        email: '',
    },
};

export default INITIAL_STATE;
